export default __webpack_public_path__ + "static/media/paddy.10ac275e.webp";